import { create } from 'zustand';

import type { AppPage, FeatureFlags, LLMStatus, NetworkStatus, PWAStatus } from '@lilith-arcana-os/domain';

interface AppState {
  networkStatus: NetworkStatus;
  pwaStatus: PWAStatus;
  featureFlags: FeatureFlags;
  llmStatus: LLMStatus;
  currentPage: AppPage;
  setNetworkStatus: (status: NetworkStatus) => void;
  setPwaStatus: (status: PWAStatus) => void;
  setFeatureFlags: (flags: FeatureFlags) => void;
  setLlmStatus: (status: LLMStatus) => void;
  setCurrentPage: (page: AppPage) => void;
}

export const useAppStore = create<AppState>((set) => ({
  networkStatus: 'online',
  pwaStatus: 'idle',
  featureFlags: {
    pwaEnabled: true,
    hostedLlmEnabled: true,
    localLmStudioEnabled: false,
    symbolicFallbackEnabled: true,
  },
  llmStatus: 'ready',
  currentPage: 'home',
  setNetworkStatus: (networkStatus) => set({ networkStatus }),
  setPwaStatus: (pwaStatus) => set({ pwaStatus }),
  setFeatureFlags: (featureFlags) => set({ featureFlags }),
  setLlmStatus: (llmStatus) => set({ llmStatus }),
  setCurrentPage: (currentPage) => set({ currentPage }),
}));
